<template>
    <div class="cell-dynamic-avatar">
        <avatar
                v-if="configured && config.type === CELL_AVATAR_TYPES.AVATAR"
                :src="config.src"
                :name="config.name"
                :size="2.5"
                class="mr-2"
                :class="config.avatarClasses"
                @click.native="handleClick"
        />

        <b-img
                v-if="configured && config.type === CELL_AVATAR_TYPES.IMAGE"
                :src="config.src"
                fluid
                class="cell-image mr-2"
                :class="config.imageClasses"
                @click.native="handleClick"
        />

        <div
                v-if="configured && config.type === CELL_AVATAR_TYPES.ICON"
                class="icon-wrapper d-flex align-center justify-content-center"
        >
            <i
                    class="cell-icon text-gray-700 cursor-pointer"
                    :class="[
                        config.icon,
                        ...config.iconClasses,
                    ]"
                    @click="handleClick"
            />
        </div>
    </div>
</template>

<script>
    import './CellDynamicAvatar.scss';
    import {AppResource} from  "@sellers-shield-home-protection/ss-core-js";

    export const CELL_AVATAR_TYPES = {
        AVATAR: 0,
        IMAGE: 1,
        ICON: 2,
    };

    export default {
        name: "CellDynamicAvatar",

        props: {
            appResource: {
                type: AppResource,
                require: false,
            },
            callback: {
                type: Function,
                required: true,
            }
        },

        data() {
            return {
                CELL_AVATAR_TYPES,
                config: null,
                configured: false,
            };
        },

        methods: {
            handleClick() {
                this.$emit('click', {
                    appResource: this.appResource,
                });
            },
        },

        async beforeMount() {
            this.config = await this.callback(this.appResource);
            this.configured = true;
        }
    };
</script>
